import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CaseService } from '../../shared/services/caseService';
import { MatAccordion } from '@angular/material/expansion';


@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css']
})
export class DetailsComponent implements OnInit {
  @Input() data;
  @Input() id;
  @ViewChild(MatAccordion) accordion: MatAccordion;
  printLoading: boolean = false;
  
  constructor(private caseService:CaseService) { }

  ngOnInit(): void {
  }
  displayPositive(key,value){
    if(key ==='RAGE' || key ==='RAGE1' || key === 'RECODEDAGE'){ 
      return false;
    }
    if( (value === '1' || value === '2' || key ==='CODICD' )){  return true;}
    return false;
  }
  displayNegative(value){
   
    if( (value === '#NULL!' || value === '' || value==='0')){  return true;}
    return false;
  }
  displayActivity(key,value){
    if(key === 'ACTIVITY_COMMENTS' ){
      return true;
    }
  }
  displayOther(key,value){
    if( !this.displayNegative(value) && !this.displayPositive(key,value) && !this.displayActivity(key,value)){  return true;}
    return false;
  }
  format(key: any, value): any {
    if (key.indexOf('COD') === 0) {
      switch (value) {
        case '#NULL!':
          return 'Test not performed';
        case '':
          return 'N/A';
        case '0':
          return 'No';
        case '1':
          return 'Yes';
        case '2':
          return 'Suspected';
        default:
          return value;
      }
    } else {
      switch (value) {
        case '#NULL!':
          return 'N/A';
        case '':
          return 'N/A';
        case '0':
          return 'Not Present';
        case '1':
          return 'Present';
        default:
          return value;
      }
    }
  }

  printModalContents() {
    this.printLoading = true;
    this.caseService.printOcmeDetails(this.id).then(pdfBlob => {
      const blobUrl = URL.createObjectURL(pdfBlob);
      const newTab = window.open(blobUrl, '_blank');
      newTab.onload = () => {
        newTab.print();
        URL.revokeObjectURL(blobUrl);
      };
      this.printLoading = false;
    }).catch(err => this.printLoading = false);
  }
}
